import { useState } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'
import { useDebounceFunc } from '../../../../hooks'
import { TABLE_MODAL_DEFAULT_PAGINATION } from '../../TableModal.constants'

export function useTableModalSearch({
  defaultPagination = TABLE_MODAL_DEFAULT_PAGINATION,
  paginationParams,
  setPagination,
  onChange,
  onLoadItems,
}) {
  const [search, setSearch] = useState(EMPTY_STRING)

  function handleChangeSearch(value) {
    const nextPagination = {
      ...paginationParams,
      page: defaultPagination.page,
    }

    setPagination(nextPagination)

    onLoadItems({
      paginationParams: nextPagination,
      searchParam: value,
    })
  }

  const {
    cancelDebounce: cancelDebouncedChangeSearch,
    debouncedHandler: debouncedHandleChangeSearch,
  } = useDebounceFunc(handleChangeSearch)

  function handleChangeSearchValue({ target: { value } }) {
    setSearch(value)
    debouncedHandleChangeSearch(value)
    onChange?.(value)
  }

  function handleClearSearch() {
    cancelDebouncedChangeSearch()
    setSearch(EMPTY_STRING)
    handleChangeSearch(EMPTY_STRING)
    onChange?.(EMPTY_STRING)
  }

  return {
    handleChangeSearchValue,
    handleClearSearch,
    search,
  }
}
